import amplitude from 'amplitude-js';

export default class Amplitude {

    instance;
    isInit = false;
    eventProperties = {};

    constructor()
    {
        this.instance = amplitude.getInstance();
    }

    init(eventProperties, userProperties, key) 
    {
        this.instance.init(key, null, {
            saveEvents: true,
            includeUtm: true,
            includeReferrer: true,
            includeGclid: true,
        }, function(instance) {
            fetch('/set_amplitude_cookie', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({deviceId: instance.options.deviceId})
            });
        });

        this.setEventProperties(eventProperties);
        this.setUserProperties(userProperties);
        this.isInit = true;
    }

    setEventProperties(eventProperties)
    {
        this.eventProperties = eventProperties;
    }

    setUserProperties(userProperties)
    {
        this.instance.setUserProperties(userProperties);
    }

    send(name, data)
    {
        if (!this.isInit) {
            return;
        }
        this.instance.logEvent(name, Object.assign(this.eventProperties, data));
    }
}

window.amplitudeInstance = new Amplitude();
